import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import { ActivatedRoute, Router } from "@angular/router";
import { AssessmentManagerService } from "app/services/angular/AssessmentManagerService";
import { ToastrService } from 'ngx-toastr';
import { Globals } from '../../globals';
import { ClientsService, SaveQuestionDto } from 'app/services/client/ClientsService';

@Component({
  providers: [AssessmentManagerService],
  selector: 'app-assessments-questions',
  templateUrl: './assessments-questions.component.html',
  styleUrls: ['./assessments-questions.component.scss']
})
export class AssessmentsQuestionsComponent implements OnInit {

    @ViewChild('selects', {static: true}) selectsElement: ElementRef;

    finish: boolean = false;
    
    questionId: number = 0;
    from: string;
    from_client: boolean;
    from_admin: boolean;
    showPage: boolean = false;

   
    assessmentsSections: any[] = [];
    
    questionsChoices: any[] = [];

    genderOptions: string[];
    ageRangeOptions: string[];
    maritalStatusOptions: string[];

    sectionsQuestionsTotal: number[] = [];
    questionsTotal: number = 0;

    /**/
    sectionQuestions: any[] = [];
    sectionChoices: any[] = [];
    questionChoices: any[] = [];

    currentSection: number = 0;
    currentQuestion: number = 0;
    globalCurrentQuestion: number = 1;
    showIcons: boolean = false; 
    singleChoice: boolean = false;

    showNextIcon: boolean = true;
    displayfirstTime: boolean = true;
    questionsContent: boolean = true;
    displayMode: number = 1;
    assignmentId: number;


    constructor
    (
        private router: Router,
        private activatedRoute: ActivatedRoute,
                //assessmentManagerService
        private _ams: AssessmentManagerService,
        private toastr: ToastrService,
        private _ClientsService: ClientsService,
        private _Globals: Globals
    )
    {
        this.activatedRoute.params.subscribe(params => {
            console.log('params',params);
            this.from = params['from'];
            this._ams.assesmentId = parseInt(params['id']);
            this.assignmentId = params['assignmentId'];

            if (isNaN(params['id'])) {
                this.toastr.error('No valid assessment id', 'ELI');
                return;
                //throw new Error("Something went badly wrong!");
            }

            //this._ams = new AssessmentManagerService();
            this._ams.loadAssessment();

            this.setAllBooleans(false);
            switch (this.from) {
                case "eli_assessments":
                    this.from_admin = true;
                    break;
                case "pending":
                    this.from_client = true;
                    break;
            }
        });
    }

    ngDoCheck() {
        this.singleChoiceStatus();
        this.showPage = this._ams.assessmentLoaded;
        this.questionsTotal = this._ams.questionsTotal;
        this.getFirstSectionQuestions();
    }

    getFirstSectionQuestions() {
        if (this._ams.sections.length > 0)
        {
            //getting the fisrt section questions
            //this.sectionQuestions = this._ams.sections[0].questions;

            
            if (this.displayfirstTime)
            {
                this.displayQuestions();
                if (this._ams.sections[0].questions.length > 0)
                    this.displayfirstTime = false;
            } 
            this.showIconsCurrentSection();
            this.getChoicesforCurrentSection();
            this.getCurrentSectionQuestionChoices();
            this.displayModeCurrentSection();
            
        }
    }

    showIconsCurrentSection()
    {
        if (this._ams.sections.length > 0)
            this.showIcons = this._ams.sections[this.currentSection].showIcons;
            //console.log('showIcons for section ' + this.currentSection, this.showIcons);
    }

    displayModeCurrentSection() {
        if (this._ams.sections.length > 0)
            this.displayMode = this._ams.sections[this.currentSection].displayMode;
        //console.log('showIcons for section ' + this.currentSection, this.showIcons);
    }

    singleChoiceStatus() {
        if (this._ams.sections.length > 0)
            this.singleChoice = this._ams.sections[this.currentSection].sigleChoice;
            //console.log('showIcons for section ' + this.currentSection, this.showIcons);
    }


    getChoicesforCurrentSection()
    {
        if (this._ams.sections.length > 0) {
            //getting the fisrt section questions
            this.sectionChoices = this._ams.sections[this.currentSection].choices;
            //console.log("Current section choices", this.sectionChoices);
        }
    }

    displayQuestions()
    {
        //display the current qustion of the current section
        console.log(this._ams.sections[this.currentSection].questions[this.currentQuestion]);
        console.log('ShowIcons for section', this.showIcons);
        console.log("Current section choices", this.sectionChoices);
        this.sectionQuestions = this._ams.sections[this.currentSection].questions;
    }

    getCurrentSectionQuestionChoices()
    {
        if (this._ams.sections.length > 0) {
            if (this._ams.sections[this.currentSection].questionsChoices.length > 0)
            {
                //getting the fisrt section questions
                for (var i = 0; i < this._ams.sections[this.currentSection].questionsChoices.length; i++) {
                    var exist = this.questionChoices.indexOf(this._ams.sections[this.currentSection].questionsChoices[i].choices);
                    if (exist != -1) {
                        //console.log("This element is already exist in the array");
                        //return;
                    } else {
                        this.questionChoices.push(this._ams.sections[this.currentSection].questionsChoices[i].choices);
                        console.log("Current question choices", this.questionChoices);
                        
                    }
                   
                }
            }
            
            
        }
    }

    showNextQuestion()
    {

        if (!this.validateSingleQuestions()) {
            return;
        }

        if (!this.validateFacesQuestions())
        {
            return;
        }

        //validate survey questions
        if (!this.validateSurveyQuestions()) {
            return;
        }

        this.globalCurrentQuestion++;
        this.currentQuestion++;

        //if the current question index is less that the current section length we display the next question
        if (this.currentQuestion < this._ams.sections[this.currentSection].questions.length && (this.displayMode != 2))//!this.showIcons)
        {
            this.displayQuestions();
        }
        else
        {
            //let questionsToAdd = this._ams.sections[this.currentSection].questions.length;
            //this.globalCurrentQuestion + questionsToAdd;
            this.currentQuestion = 0;
            this.showNextSection();
            
        }
        console.log("Current section choices", this.sectionChoices);
    }

    showNextSection()
    {
        this.currentSection++;
        let questionsToAdd = 0;
        for (var i = 0; i < this.currentSection; i++)
        {
            questionsToAdd += this._ams.sections[i].questions.length;
        }
        
        this.currentQuestion += questionsToAdd +1;
        //if the current question is major we show the next section
        if (this.currentSection < this._ams.sections.length) {
            console.log('---new section---');
            console.log('ShowIcons for section', this.showIcons);
            console.log("Current section choices", this.sectionChoices);
            this.globalCurrentQuestion = this.currentQuestion;
            this.currentQuestion = 0;
            this.displayQuestions();
            this.getChoicesforCurrentSection();
            this.getCurrentSectionQuestionChoices();
            this.showIconsCurrentSection();
            this.displayModeCurrentSection();

        }
        // if the current secction is major that all sections the assessment is finished
        else {
            console.log("---Assessment finished!---");
            this.currentSection = 0;
            this.currentQuestion = 0;
            this.showNextIcon = false;
            this.sectionQuestions = [];
            this.sectionChoices = [];
            this.questionsContent = false;
            this.finish = true;
        }
    }

    ngOnInit() { }

    setAllBooleans(status: boolean) {
        this.from_admin = status;
        this.from_client = status;
    }  

    finishAssessment() {
      this.router.navigate(['/app/pending']);
  }

    selectFace(event: any, questionIndex: string) {
        //console.log(this._ams.sections[this.currentSection].questions[this.currentQuestion]);
        let answerId = event.target.dataset.choiceId;
        let questionId = event.target.dataset.questionId;

        console.log('choiceId', questionId);
        console.log('answerId', answerId);
        //console.log(event);

        let children = event.target.parentNode.parentNode.children.length;
        for (let i = 0; i < children; i++) {
            event.target.parentNode.parentNode.children[i].children["0"].classList.remove('active');
        }
        event.target.classList.add('active');
        this.setSelectedFaceValue(questionIndex, event.target.classList["0"]);

        this.saveAssessmentAnswer(questionId, answerId);
        //.target.parentNode.parentNode.children[3].children["0"].classList
    }

    setSelectedFaceValue(questionIndex: string,classValue: string) {
        $("input[name='face" + questionIndex + "']").val(classValue);
        $("input[name='face" + questionIndex + "']").prop('checked', true);
        console.log(classValue);
    }

    validateSingleQuestions(): boolean
    {
        if (!this.showIcons && this.singleChoice) {
            let answer = $('input[name=answers]:checked').val();
            console.log(answer);
            if (answer == undefined) {
                //alert('Please select one answer');
                this.toastr.warning('Please select one answer.', 'ELI');
                return false;
            }
            else
            {
                $('input[name=answers]').prop('checked', false);
                $('.btn-group label').removeClass('active');
                return true;
            }

            
        }
        else
        {
            return true;
        }
        
    }

    validateFacesQuestions(): boolean
    {
        if (this.showIcons && this.singleChoice) {
            let allCompleted = true;
            let sectionQuestions = this._ams.sections[this.currentSection].questions.length;
            for (var i = this.globalCurrentQuestion; i < this.globalCurrentQuestion + sectionQuestions; i++)
            {
                let answer = $("input[name='face" + i + "']").val();
                if (answer == '') {
                    //alert('Please complete all questions');
                    this.toastr.warning('Please complete all questions.', 'ELI');
                    allCompleted = false;
                    return allCompleted;
                }
            }
            return allCompleted;
        }
        else
        {
            return true;
        }
    }

    validateSurveyQuestions(): boolean {
        if (!this.showIcons && !this.singleChoice) {
            let selects = this.selectsElement.nativeElement.getElementsByTagName('select');
            let allSelected = true;
            for (var i = 0; i < selects.length; i++){
                if (selects[i].selectedIndex == 0) {
                    this.toastr.warning('Please complete all options.', 'ELI');
                    return allSelected = false;
                }
            }
            return allSelected;
        }
        else
        {
            return true;
        }
    }

    setOneActive(event: any)
    {
        //console.log(event);
        let answerId = event.target.id;
        let children = event.target.parentNode.parentNode.children.length;
        for (let i = 0; i < children; i++) {
            //let lastClass = event.target.parentNode.parentNode.children[i].children["0"].classList.length
            event.target.parentNode.parentNode.children[i].children["0"].classList.remove('active');
        }
        event.target.classList.add('active');
        //.target.parentNode.parentNode.children[3].children["0"].classList

        let questionId = this._ams.sections[this.currentSection].questions[this.currentQuestion].Id;
        this.saveAssessmentAnswer(questionId, answerId);
        
    }

    selectSurvey(selected: any, event: any) {
        //console.log(event);
        //console.log(this._ams.sections[this.currentSection].questions);

        let questionId = parseInt(event.target.selectedOptions[0].dataset.questionId);
        console.log('questionId', questionId);

        let selectedValue = selected;
        console.log('survey selected', selectedValue);

        //validation for index 0 of the options
        if (selectedValue != '') {
            this.saveAssessmentAnswer(questionId, selectedValue);
        }
        
    }


    saveAssessmentAnswer(questionId: number, answerId: number): boolean {
        //console.log(this._ams.sections[this.currentSection].questions[this.currentQuestion]);
        if (this.assignmentId != 0) {
            let sectionId = this._ams.sections[this.currentSection].sectionId;
            

            let question = new SaveQuestionDto();
            question.ClientId = this._Globals.getUserId(); 
            question.AssignedAssessmentId = this.assignmentId;
            question.SectionId = sectionId;
            question.QuestionId = questionId;
            question.Answer = answerId;

            console.log('current question answer', question);

            this._ClientsService.postSaveAssessmentAnswer(question).subscribe((data:any) => {
                console.log(data);
                if (data.result.Result > 0) {
                    return true;
                } else {
                    this.toastr.error('We are sorry. An unexpected error happened while trying to register your answer. Please try again. If the problem persists please contact Technical Support.', 'ELI');
                    return false;
                }
            });
        } else {
            console.log('preview mode');
            return false;
        }
    }
    

}
